import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, vModelText as _vModelText, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-a90de2af"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["disabled"]
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("legend", null, "Hunt builder · Sandbox", -1 /* HOISTED */))
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "nge-hb-admin-help" }, [
  /*#__PURE__*/_createTextVNode("Players help build a Hunt. Add cells that need full proofreading: each goes in the Cell Library marked "),
  /*#__PURE__*/_createElementVNode("b", null, "Hunt candidate"),
  /*#__PURE__*/_createTextVNode(". When it is proofread, either build the Hunt from the proofreaders' own edits, or open suggestions to everyone with production access until a closing time: their merges and cuts are kept, never sent. Then plant the ones you like, finish planting, and make the Hunt. From planting (or building) on, players can't see the cell in Pyr until the Hunt starts.")
], -1 /* HOISTED */))
const _hoisted_4 = {
  class: "nge-hb-stages",
  "aria-label": "The stages, in order"
}
const _hoisted_5 = ["aria-describedby"]
const _hoisted_6 = { class: "nge-hb-stage-n" }
const _hoisted_7 = { class: "nge-hb-stage-word" }
const _hoisted_8 = {
  key: 0,
  class: "nge-hb-stage-count"
}
const _hoisted_9 = ["id"]
const _hoisted_10 = {
  key: 0,
  class: "nge-hb-admin-warn"
}
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("code", null, "supabase-hunt-build.sql", -1 /* HOISTED */))
const _hoisted_12 = { class: "nge-hb-admin-add" }
const _hoisted_13 = ["disabled"]
const _hoisted_14 = {
  key: 1,
  class: "nge-hb-admin-error",
  role: "alert"
}
const _hoisted_15 = {
  key: 2,
  class: "nge-hb-admin-msg",
  role: "status"
}
const _hoisted_16 = {
  key: 3,
  class: "nge-hb-admin-muted"
}
const _hoisted_17 = {
  key: 4,
  class: "nge-hb-admin-muted"
}
const _hoisted_18 = { class: "nge-hb-admin-list" }
const _hoisted_19 = ["aria-expanded", "onClick"]
const _hoisted_20 = { class: "nge-hb-admin-id" }
const _hoisted_21 = ["title"]
const _hoisted_22 = { class: "nge-hb-admin-who" }
const _hoisted_23 = { class: "nge-hb-admin-counts" }
const _hoisted_24 = {
  key: 0,
  class: "nge-hb-admin-body"
}
const _hoisted_25 = {
  key: 0,
  class: "nge-hb-admin-actions"
}
const _hoisted_26 = ["onUpdate:modelValue", "aria-label"]
const _hoisted_27 = ["disabled"]
const _hoisted_28 = ["disabled", "onClick"]
const _hoisted_29 = { class: "nge-hb-admin-muted" }
const _hoisted_30 = { class: "nge-hb-admin-field" }
const _hoisted_31 = { class: "nge-hb-admin-actions" }
const _hoisted_32 = ["disabled", "onClick"]
const _hoisted_33 = { class: "nge-hb-admin-num" }
const _hoisted_34 = ["onUpdate:modelValue"]
const _hoisted_35 = { class: "nge-hb-admin-num" }
const _hoisted_36 = ["onUpdate:modelValue"]
const _hoisted_37 = { class: "nge-hb-admin-num" }
const _hoisted_38 = ["disabled", "onClick"]
const _hoisted_39 = {
  key: 0,
  class: "nge-hb-admin-muted"
}
const _hoisted_40 = {
  key: 2,
  class: "nge-hb-admin-field"
}
const _hoisted_41 = { class: "nge-hb-admin-actions" }
const _hoisted_42 = ["disabled", "onClick"]
const _hoisted_43 = ["disabled", "onClick"]
const _hoisted_44 = ["disabled", "onClick"]
const _hoisted_45 = ["disabled", "title", "onClick"]
const _hoisted_46 = ["disabled", "onClick"]
const _hoisted_47 = {
  key: 5,
  class: "nge-hb-admin-past"
}
const _hoisted_48 = { class: "nge-hb-admin-list" }
const _hoisted_49 = { class: "nge-hb-admin-line nge-hb-admin-line--static" }
const _hoisted_50 = { class: "nge-hb-admin-id" }
const _hoisted_51 = { class: "nge-hb-admin-chip" }
const _hoisted_52 = { class: "nge-hb-admin-who" }
const _hoisted_53 = ["disabled", "onClick"]

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return (_openBlock(), _createElementBlock("fieldset", {
    class: "nge-hb-admin",
    disabled: $setup.busy === 'load'
  }, [
    _hoisted_2,
    _hoisted_3,
    _createElementVNode("ol", _hoisted_4, [
      (_openBlock(), _createElementBlock(_Fragment, null, _renderList($setup.STAGES, (st, i) => {
        return _createElementVNode("li", {
          key: st.key,
          class: _normalizeClass(["nge-hb-stage", { 'nge-hb-stage--some': $setup.stageCount(st.key) }]),
          tabindex: "0",
          "aria-describedby": `nge-hb-tip-${st.key}`
        }, [
          _createElementVNode("span", _hoisted_6, _toDisplayString(i + 1), 1 /* TEXT */),
          _createElementVNode("span", _hoisted_7, _toDisplayString(st.word), 1 /* TEXT */),
          ($setup.stageCount(st.key))
            ? (_openBlock(), _createElementBlock("span", _hoisted_8, _toDisplayString($setup.stageCount(st.key)), 1 /* TEXT */))
            : _createCommentVNode("v-if", true),
          _createElementVNode("span", {
            id: `nge-hb-tip-${st.key}`,
            class: "nge-hb-stage-tip",
            role: "tooltip"
          }, [
            _createElementVNode("b", null, _toDisplayString(i + 1) + ". " + _toDisplayString(st.word), 1 /* TEXT */),
            _createTextVNode(" " + _toDisplayString(st.tip), 1 /* TEXT */)
          ], 8 /* PROPS */, _hoisted_9)
        ], 10 /* CLASS, PROPS */, _hoisted_5)
      }), 64 /* STABLE_FRAGMENT */))
    ]),
    ($setup.notInstalled)
      ? (_openBlock(), _createElementBlock("p", _hoisted_10, [
          _createTextVNode("The Hunt Builder is not set up yet: run "),
          _hoisted_11,
          _createTextVNode(" in Supabase.")
        ]))
      : _createCommentVNode("v-if", true),
    _createElementVNode("div", _hoisted_12, [
      _withDirectives(_createElementVNode("textarea", {
        "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => (($setup.paste) = $event)),
        class: "nge-hb-admin-input nge-hb-admin-paste",
        rows: "2",
        placeholder: "One cell a line: its ID, then its soma x, y, z (as the coordinate bar shows)",
        "aria-label": "Sandbox cells to add: ID, then soma x, y, z"
      }, null, 512 /* NEED_PATCH */), [
        [_vModelText, $setup.paste]
      ]),
      _createElementVNode("button", {
        class: "nge-hb-admin-btn nge-hb-admin-btn--primary",
        disabled: !!$setup.busy || !$setup.paste.trim(),
        onClick: $setup.add
      }, _toDisplayString($setup.busy === 'add' ? 'Adding…' : 'Add candidates'), 9 /* TEXT, PROPS */, _hoisted_13)
    ]),
    ($setup.error)
      ? (_openBlock(), _createElementBlock("p", _hoisted_14, _toDisplayString($setup.error), 1 /* TEXT */))
      : _createCommentVNode("v-if", true),
    ($setup.message)
      ? (_openBlock(), _createElementBlock("p", _hoisted_15, _toDisplayString($setup.message), 1 /* TEXT */))
      : _createCommentVNode("v-if", true),
    ($setup.busy === 'load')
      ? (_openBlock(), _createElementBlock("p", _hoisted_16, "Loading…"))
      : (!$setup.rows.length && !$setup.notInstalled)
        ? (_openBlock(), _createElementBlock("p", _hoisted_17, "No Hunt cells yet."))
        : _createCommentVNode("v-if", true),
    _createElementVNode("ul", _hoisted_18, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.live, (r) => {
        return (_openBlock(), _createElementBlock("li", {
          key: r.id,
          class: _normalizeClass(["nge-hb-admin-row", { 'nge-hb-admin-row--open': $setup.open === r.id }])
        }, [
          _createElementVNode("button", {
            class: "nge-hb-admin-line",
            "aria-expanded": $setup.open === r.id,
            onClick: $event => ($setup.toggle(r))
          }, [
            _createElementVNode("span", _hoisted_20, "…" + _toDisplayString(r.root.slice(-6)), 1 /* TEXT */),
            _createElementVNode("span", {
              class: _normalizeClass(["nge-hb-admin-chip", [`nge-hb-admin-chip--${r.status}`, { 'nge-hb-admin-chip--closed': r.closed }]]),
              title: $setup.stageTip(r)
            }, _toDisplayString($setup.statusWord(r)), 11 /* TEXT, CLASS, PROPS */, _hoisted_21),
            _createElementVNode("span", _hoisted_22, _toDisplayString(r.status === 'proofreading' ? (r.task?.who ? `${r.task.who} is on it` : 'Waiting for a proofreader') : $setup.who(r)), 1 /* TEXT */),
            _createElementVNode("span", _hoisted_23, _toDisplayString($setup.countsLine(r)), 1 /* TEXT */)
          ], 8 /* PROPS */, _hoisted_19),
          ($setup.open === r.id)
            ? (_openBlock(), _createElementBlock("div", _hoisted_24, [
                (['proofreading', 'proofread'].includes(r.status))
                  ? (_openBlock(), _createElementBlock("div", _hoisted_25, [
                      _createElementVNode("span", {
                        class: _normalizeClass(["nge-hb-admin-num", { 'nge-hb-admin-nosoma': !r.start }])
                      }, "Soma " + _toDisplayString(r.start ? '' : '(not set: say which cell is meant)'), 3 /* TEXT, CLASS */),
                      (_openBlock(), _createElementBlock(_Fragment, null, _renderList(3, (k) => {
                        return _withDirectives(_createElementVNode("input", {
                          key: k,
                          "onUpdate:modelValue": $event => (($setup.somaAt[k - 1]) = $event),
                          type: "number",
                          class: "nge-hb-admin-xyz",
                          "aria-label": ['x', 'y', 'z'][k - 1]
                        }, null, 8 /* PROPS */, _hoisted_26), [
                          [
                            _vModelText,
                            $setup.somaAt[k - 1],
                            void 0,
                            { number: true }
                          ]
                        ])
                      }), 64 /* STABLE_FRAGMENT */)),
                      _createElementVNode("button", {
                        class: "nge-hb-admin-btn",
                        disabled: !!$setup.busy,
                        title: "The point at the center of the view",
                        onClick: $setup.somaFromCrosshair
                      }, "Use the crosshair", 8 /* PROPS */, _hoisted_27),
                      _createElementVNode("button", {
                        class: "nge-hb-admin-btn",
                        disabled: !!$setup.busy || $setup.somaAt.some(v => !Number.isFinite(Number(v)) || v === ''),
                        onClick: $event => ($setup.saveSoma(r))
                      }, _toDisplayString($setup.busy === `soma${r.id}` ? 'Saving…' : 'Save soma'), 9 /* TEXT, PROPS */, _hoisted_28)
                    ]))
                  : _createCommentVNode("v-if", true),
                _createElementVNode("p", _hoisted_29, [
                  _createTextVNode("Cell "),
                  _createElementVNode("code", null, _toDisplayString(r.root), 1 /* TEXT */),
                  (r.proofread_at)
                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                        _createTextVNode(" · proofread " + _toDisplayString($setup.when(r.proofread_at)) + " by " + _toDisplayString(r.proofread_by || 'a player'), 1 /* TEXT */)
                      ], 64 /* STABLE_FRAGMENT */))
                    : _createCommentVNode("v-if", true),
                  (r.hunt_id)
                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                        _createTextVNode(" · Hunt #" + _toDisplayString(r.hunt_id), 1 /* TEXT */)
                      ], 64 /* STABLE_FRAGMENT */))
                    : _createCommentVNode("v-if", true)
                ]),
                (['proofread', 'suggesting'].includes(r.status))
                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                      _createElementVNode("label", _hoisted_30, [
                        _createTextVNode("Also invite (optional: everyone with production access can already suggest) "),
                        _withDirectives(_createElementVNode("input", {
                          "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => (($setup.helpersText) = $event)),
                          class: "nge-hb-admin-input",
                          placeholder: "names of players without production access",
                          "aria-label": "Also invite, by name"
                        }, null, 512 /* NEED_PATCH */), [
                          [_vModelText, $setup.helpersText]
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_31, [
                        _createElementVNode("button", {
                          class: "nge-hb-admin-btn",
                          disabled: !!$setup.busy,
                          onClick: $event => ($setup.saveHelpers(r))
                        }, _toDisplayString($setup.busy === `help${r.id}` ? 'Saving…' : 'Save helpers'), 9 /* TEXT, PROPS */, _hoisted_32),
                        _createElementVNode("label", _hoisted_33, [
                          _createTextVNode("Merges each "),
                          _withDirectives(_createElementVNode("input", {
                            "onUpdate:modelValue": $event => ((r.merges_each) = $event),
                            type: "number",
                            min: "0",
                            max: "10"
                          }, null, 8 /* PROPS */, _hoisted_34), [
                            [
                              _vModelText,
                              r.merges_each,
                              void 0,
                              { number: true }
                            ]
                          ])
                        ]),
                        _createElementVNode("label", _hoisted_35, [
                          _createTextVNode("Cuts each "),
                          _withDirectives(_createElementVNode("input", {
                            "onUpdate:modelValue": $event => ((r.cuts_each) = $event),
                            type: "number",
                            min: "0",
                            max: "10"
                          }, null, 8 /* PROPS */, _hoisted_36), [
                            [
                              _vModelText,
                              r.cuts_each,
                              void 0,
                              { number: true }
                            ]
                          ])
                        ]),
                        _createElementVNode("label", _hoisted_37, [
                          _createTextVNode("Suggestions close (ET) "),
                          _withDirectives(_createElementVNode("input", {
                            "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => (($setup.closeAt) = $event)),
                            type: "datetime-local",
                            class: "nge-hb-admin-when",
                            "aria-label": "When suggestions close, Eastern time"
                          }, null, 512 /* NEED_PATCH */), [
                            [_vModelText, $setup.closeAt]
                          ])
                        ]),
                        _createElementVNode("button", {
                          class: "nge-hb-admin-btn",
                          disabled: !!$setup.busy,
                          onClick: $event => ($setup.saveCounts(r))
                        }, "Save", 8 /* PROPS */, _hoisted_38)
                      ]),
                      (r.status === 'suggesting')
                        ? (_openBlock(), _createElementBlock("p", _hoisted_39, _toDisplayString(r.closed ? `Closed ${$setup.etLine(r.suggest_until)}: helpers can't add more. The cell stays locked; start planting when you are ready.` : r.suggest_until ? `Open until ${$setup.etLine(r.suggest_until)}.` : 'Open until you close them.'), 1 /* TEXT */))
                        : _createCommentVNode("v-if", true)
                    ], 64 /* STABLE_FRAGMENT */))
                  : _createCommentVNode("v-if", true),
                (r.status === 'proofread')
                  ? (_openBlock(), _createElementBlock("label", _hoisted_40, [
                      _createTextVNode("Note if you send it back "),
                      _withDirectives(_createElementVNode("input", {
                        "onUpdate:modelValue": _cache[3] || (_cache[3] = $event => (($setup.sendBackNote) = $event)),
                        class: "nge-hb-admin-input",
                        maxlength: "500",
                        placeholder: "The axon past the bend still needs work"
                      }, null, 512 /* NEED_PATCH */), [
                        [_vModelText, $setup.sendBackNote]
                      ])
                    ]))
                  : _createCommentVNode("v-if", true),
                _createElementVNode("div", _hoisted_41, [
                  (r.status !== 'proofreading')
                    ? (_openBlock(), _createElementBlock("button", {
                        key: 0,
                        class: "nge-hb-admin-btn",
                        disabled: !!$setup.busy,
                        onClick: $event => ($setup.look(r))
                      }, "Look at it", 8 /* PROPS */, _hoisted_42))
                    : _createCommentVNode("v-if", true),
                  (['suggesting', 'planting', 'building', 'in_hunt'].includes(r.status))
                    ? (_openBlock(), _createElementBlock("button", {
                        key: 1,
                        class: "nge-hb-admin-btn nge-hb-admin-btn--gold",
                        disabled: !!$setup.busy,
                        onClick: $event => ($setup.goThrough(r))
                      }, "Go through the suggestions", 8 /* PROPS */, _hoisted_43))
                    : _createCommentVNode("v-if", true),
                  (r.status === 'building')
                    ? (_openBlock(), _createElementBlock("button", {
                        key: 2,
                        class: "nge-hb-admin-btn nge-hb-admin-btn--primary",
                        disabled: !!$setup.busy,
                        onClick: $event => ($setup.emit('make', r.id))
                      }, "Make the Hunt", 8 /* PROPS */, _hoisted_44))
                    : _createCommentVNode("v-if", true),
                  (r.status === 'in_hunt' || r.status === 'building' || r.status === 'planting')
                    ? (_openBlock(), _createElementBlock("button", {
                        key: 3,
                        class: "nge-hb-admin-btn",
                        disabled: !!$setup.busy,
                        title: r.status === 'in_hunt' ? 'After the Hunt ends: undo every planting, so the cell is as it was proofread' : 'Undo every planting now',
                        onClick: $event => ($setup.doPutBack(r))
                      }, _toDisplayString($setup.busy === `back${r.id}` ? 'Putting back…' : 'Put it back'), 9 /* TEXT, PROPS */, _hoisted_45))
                    : _createCommentVNode("v-if", true),
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(r.moves, (to) => {
                    return (_openBlock(), _createElementBlock("button", {
                      key: to,
                      class: _normalizeClass(["nge-hb-admin-btn", { 'nge-hb-admin-btn--primary': to === 'suggesting' || to === 'planting' || to === 'building' }]),
                      disabled: !!$setup.busy,
                      onClick: $event => ($setup.move(r, to))
                    }, _toDisplayString($setup.busy === `move${r.id}` ? 'Saving…' : $setup.moveWord(r, to)), 11 /* TEXT, CLASS, PROPS */, _hoisted_46))
                  }), 128 /* KEYED_FRAGMENT */))
                ])
              ]))
            : _createCommentVNode("v-if", true)
        ], 2 /* CLASS */))
      }), 128 /* KEYED_FRAGMENT */))
    ]),
    ($setup.past.length)
      ? (_openBlock(), _createElementBlock("details", _hoisted_47, [
          _createElementVNode("summary", null, "Put back and dropped (" + _toDisplayString($setup.past.length) + ")", 1 /* TEXT */),
          _createElementVNode("ul", _hoisted_48, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.past, (r) => {
              return (_openBlock(), _createElementBlock("li", {
                key: r.id,
                class: "nge-hb-admin-row"
              }, [
                _createElementVNode("span", _hoisted_49, [
                  _createElementVNode("span", _hoisted_50, "…" + _toDisplayString(r.root.slice(-6)), 1 /* TEXT */),
                  _createElementVNode("span", _hoisted_51, _toDisplayString($setup.STATUS_WORD[r.status]), 1 /* TEXT */),
                  _createElementVNode("span", _hoisted_52, _toDisplayString($setup.who(r)), 1 /* TEXT */),
                  (r.status === 'dropped' || r.status === 'put_back')
                    ? (_openBlock(), _createElementBlock("button", {
                        key: 0,
                        class: "nge-hb-admin-btn nge-hb-admin-btn--small",
                        disabled: !!$setup.busy,
                        title: "Back to stage 1: its Cell Library task is Available again, under the cell's ID now, for anyone to claim and proofread",
                        onClick: $event => ($setup.move(r, 'proofreading'))
                      }, _toDisplayString(r.status === 'put_back' ? 'Proofread again' : 'Bring back'), 9 /* TEXT, PROPS */, _hoisted_53))
                    : _createCommentVNode("v-if", true)
                ])
              ]))
            }), 128 /* KEYED_FRAGMENT */))
          ])
        ]))
      : _createCommentVNode("v-if", true)
  ], 8 /* PROPS */, _hoisted_1))
}